import { defineStore } from 'pinia'

interface LoadingState {
  isLoading: boolean
  loadingCount: number
  loadingTimeout: number | null
}

export const useLoadingStore = defineStore('loading', {
  state: (): LoadingState => ({
    isLoading: false,
    loadingCount: 0,
    loadingTimeout: null
  }),

  actions: {
    startLoading() {
      this.loadingCount++
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout)
        this.loadingTimeout = null
      }
      this.isLoading = true
    },

    stopLoading() {
      this.loadingCount = Math.max(0, this.loadingCount - 1)
      
      if (this.loadingCount === 0) {
        // Add a small delay before hiding the loading bar to prevent flashing
        this.loadingTimeout = window.setTimeout(() => {
          this.isLoading = false
          this.loadingTimeout = null
        }, 300)
      }
    },

    resetLoading() {
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout)
      }
      this.loadingCount = 0
      this.isLoading = false
      this.loadingTimeout = null
    }
  }
})

export type LoadingStore = ReturnType<typeof useLoadingStore> 